import { Container, Flex, Heading, Grid, Box } from '@radix-ui/themes';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/fasttrac/contexts/use-tenant-context';
import { Button } from '@trashlab/sitesapp/src/organizations/fasttrac/template/components/shared/button';
import { GoogleReviews } from '@trashlab/sitesapp/src/organizations/fasttrac/template/components/shared/google-reviews';
import { Card } from '@trashlab/sitesapp/src/organizations/fasttrac/template/components/shared/card';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/fasttrac/lib/utils/get-variant-value';
import { useState } from 'react';
import { DumpsterModal } from '@trashlab/sitesapp/src/organizations/fasttrac/template/components/shared/modal/dumpster-modal';
import { asAddress } from '@trashlab/api/src/library/server/utils/json-compatibility';

export const CtaSection = ({
  secondary = false,
  withBackground = false,
}: {
  secondary?: boolean;
  withBackground?: boolean;
}) => {
  const { website } = useTenantContext();
  const orgAddress = asAddress(website?.organization?.address as any);

  const city = orgAddress?.city ?? 'San Francisco';
  const state = orgAddress?.state ?? 'CA';

  const ctaText = useVariantValue(
    'CTA_TEXT',
    `Best residential and commercial dumpster rental in ${city}, ${state}`,
  );

  const ctaButtonText = useVariantValue(
    'CTA_BUTTON_TEXT',
    'Explore our services',
  );

  return (
    <Container
      size="4"
      p="8"
      className={
        withBackground
          ? `relative min-h-[200px] overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-[url('/default/rental-steps-bg.svg')] before:bg-cover before:bg-center before:bg-no-repeat before:opacity-100 before:-z-10 after:content-[''] after:absolute after:inset-0 after:opacity-90 after:-z-10`
          : ''
      }
    >
      <Card backgroundColor={secondary ? 'primary' : 'white'} width="100%">
        <Flex direction="column" gap="4" className="relative w-full">
          <GoogleReviews dark={secondary} />
          <Grid
            columns={{ initial: '1', sm: '2' }}
            gap="4"
            width="auto"
            justify="between"
            align="center"
          >
            <Heading
              as="h2"
              size={{ initial: '6', sm: '7', md: '8' }}
              className={`${
                secondary ? 'text-white' : ''
              } w-full whitespace-normal break-words`}
              data-variable="CTA_TEXT"
            >
              {ctaText}
            </Heading>

            <Box className="flex justify-end">
              <Button
                withArrow
                isDark={secondary}
                scrollToDumpsterTypes
                className="flex-1 md:flex-none"
                data-variable="CTA_BUTTON_TEXT"
              >
                {ctaButtonText}
              </Button>
            </Box>
          </Grid>
        </Flex>
      </Card>
    </Container>
  );
};

export default CtaSection;
